<script setup lang="ts">
import { eventBus } from "#bb/lib/eventBus";

const props = defineProps<{ id: string }>();

const { getContentById } = useContentManager();
const definitionData = computed(() => getContentById(props.id));

const features = inject("render-features", { editor: false });

const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Footer editors",
    commands: [
      {
        id: "edit",
        name: "Edit",
        description: "Edit this footer",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: definitionData.value,
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Footer",
    icon: "lucide:panel-bottom",
  },
});
</script>

<template>
  <div
    v-if="features.editor"
    class="inline-flex items-center gap-2 rounded-sm border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground"
  >
    <Icon mode="svg" size="14" name="lucide:panel-bottom" />
    Footer (rendered in PDF export)
  </div>

  <div v-if="features.editor" class="hidden">
    <editor-reports-page-footer :id="props.id" />
  </div>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";

export default {
  componentId: ComponentDefinitionIds.PAGE_FOOTER,
  icon: "lucide:panel-bottom",
  editor: () => import("#bb/components/editor/reports/page-footer.vue"),
  type: "Footer",
  description: "Defines the PDF report page footer rendered by the export compiler.",
  default: {
    content: "",
    showPageNumber: true,
  },
  categories: ["Reports"],
  order: 12013,
};
</script>
